import { Card, Typography } from "@material-ui/core";
import type { SxProps } from "@material-ui/system";
import type { CSSProperties } from "react";

// ----------------------------------------------------------------------

type GenericBannerProps = {
  sx?: SxProps;
  style?: CSSProperties;
  title: string;
  content: JSX.Element;
  backgroundColor: string;
  titleTextColor: string;
  bodyTextColor: string;
};

export default function GenericBanner({
  sx,
  style,
  title,
  content,
  backgroundColor,
  titleTextColor,
  bodyTextColor
}: GenericBannerProps) {
  return (
    <Card
      elevation={2}
      style={style}
      sx={{
        p: 3,
        mt: 1,
        mb: 2,
        overflow: "auto",
        backgroundColor: backgroundColor,
        ...sx
      }}
    >
      <Typography variant="h5" sx={{ flexGrow: 1, color: titleTextColor }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ flexGrow: 1, color: bodyTextColor }}>
        {content}
      </Typography>
    </Card>
  );
}
